import React, { useState } from "react";
import { Box, Typography, Button, CircularProgress, Card, List, ListItem, ListItemText, Divider, useTheme } from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";


const Unauthorized = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const livelyBackground = theme.palette.mode === 'light' ? colors.primary[600] : colors.primary[Math.max(50, 600 - 100)];

  return (
    <>
      <Box m="20px">
        <Header title="Authorized" subtitle="" />
        <Box height="75vh">
            <Card sx={{ p: 3, textAlign: "center", backgroundColor: livelyBackground, borderRadius: "16px", boxShadow: 4 }}>
              <Typography variant="h4" gutterBottom>
                You are not authorized to access this page.
              </Typography>
            </Card>
          </Box>
      </Box>
    </>
  );
};

export default Unauthorized;
